import WebPageLayout from "../../layouts/WebPageLayout";
import React, { useRef, useEffect, useState } from "react";
import { Card, Row, Col } from "antd";
import TablePageLayout from "../../layouts/TablePageLayout";
import { useLazyGetDashboardQuery } from "../../../../store/services/api/dashboard-api";
import DashboardViewFilters from "./DashboardViewFilters";
import { DateTime } from "luxon";
import {
  OrderedListOutlined,
  ClockCircleOutlined,
  ScheduleOutlined,
  HourglassOutlined,
} from "@ant-design/icons";
import { BaseFilters } from "../../../web/hooks/useFilters";
import { WorkOrderPriority, WorkOrderStatus, WorkOrderType } from "../../../../store/data/entities/work-order";
import useEntityListPage from "../../hooks/useEntityListPage";
import { StyleSheet, View } from "react-native";

import BuildingMap from "./BuildingMap";
import PreventiveCorrectiveChart from "./PreventiveCorrectiveChart";
import AssetRankBarChart from "./AssetRankBarChart";
import StatusPie from "./StatusPie";
import WorkOrderPerAssetChart from "./AssetTypeBarChart";
import { useWindowDimensions } from "react-native";
import { Drawer } from "antd";
import {Button} from "react-native-paper";
import DashboardOpenWorkOrdersModal from "../../../../components/modals/DashboardOpenWorkOrdersModal";
import DashboardOverDueWorkOrdersModal from "../../../../components/modals/DashboardOverDueWorkOrdersModal";
import DashboardTicketModal from "../../../../components/modals/DashboardTicketModal";

interface DashboardViewFilters {
  buildingId?: string[];
  buildingLeadId?: string[];
  technicianId?: string[];
  assetTypeId?: string[];  
  type?: WorkOrderType[];
  statuses?: WorkOrderStatus[];
  priority?: WorkOrderPriority[];
  
}

export default function DashboardView() {
  const {
    filter,
    tableData: dashboardData,
    onSubmitFilter,
  } = useEntityListPage<DashboardViewFilters>({
    entityName: "Dashboard",
    lazyTableQuery: useLazyGetDashboardQuery,
    
  });

  const [WOModalOpen, setOpenWOModalOpen] = useState(false);
  const [overDueWOModalOpen, setOverDueWOModalOpen] = useState(false);
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  

  const { width } = useWindowDimensions();
  const isSmallScreen = width < 1200;
  const [showFilters, setShowFilters] = useState(false);

  const chartContainerStyle = {
    ...styles.chartContainer,
    padding: isSmallScreen ? 3 : 8,
  };
  const gapStyle = {
    gap: isSmallScreen ? 4 : 8,
  };
  const marginStyle = {
    marginBottom: isSmallScreen ? 4 : 8,
  };

  const imageData = dashboardData?.imageDto.workOrdersPerBuilding || [];

  const PreventiveChartRef = useRef<HTMLDivElement>(null);
  const AssetRankBarRef = useRef<HTMLDivElement>(null);
  const StatusPieRef = useRef<HTMLDivElement>(null);
  const buildingRef = useRef<HTMLDivElement>(null);


  const [AssetRankBarSize, setAssetRankBarSize] = useState({ width: 0, height: 0 });
  const [StatusPieSize, setStatusPieSize] = useState({ width: 0, height: 0 });
  const [buildingSize, setbuildingSize] = useState({ width: 0, height: 0 });
  const [PreventiveChartSize, setPreventiveChartSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
      if (!AssetRankBarRef.current) return;
        const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setAssetRankBarSize({ width, height });
        }
        });
        observer.observe(AssetRankBarRef.current);
        return () => observer.disconnect(); 
      
    }, []);
    useEffect(() => {
      if (!StatusPieRef.current) return;
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setStatusPieSize({ width, height });
        }
        });
        observer.observe(StatusPieRef.current);
        return () => observer.disconnect();
  
      
    }, []);
    useEffect(() => {
      if (!PreventiveChartRef.current) return;
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setPreventiveChartSize({ width, height });
        }
        });
        observer.observe(PreventiveChartRef.current);
        return () => observer.disconnect();
  
      
    }, []);
    useEffect(() => {
      if (!buildingRef.current) return;
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          setbuildingSize({width: width, height: height });
        }
        });
        observer.observe(buildingRef.current);
        return () => observer.disconnect();
  
      
    }, []);

    const handleCardClick = (index: number) => {
      switch (index) {
        case 0:
          setOpenWOModalOpen(true);
          break;
        case 1:
          setOverDueWOModalOpen(true);
          break;
        case 3:
          setTicketModalOpen(true);
          break;
        }

    };


  const cards = [
    {
      title: "Total Open WO:",
      value: dashboardData?.dashboardCountDto.openWorkOrders?.length ?? 0,
      icon: <OrderedListOutlined />,
    },
    {
      title: "Overdue WO:",
      value:
        dashboardData?.dashboardCountDto.overDueWorkOrdersCount != null
          ? `${dashboardData.dashboardCountDto.overDueWorkOrdersCount}%`
          : "0%",
      icon: <ClockCircleOutlined />,
    },
    {
      title: "WO Days Open Average:",
      value: dashboardData?.dashboardCountDto.dayOpenAvg ?? 0,
      icon: <ScheduleOutlined />,
    },
    {
      title: "GC Infra Open Tickets:",
      value: dashboardData?.dashboardCountDto.openTickets?.length ?? 0,
      icon: <HourglassOutlined />,
    },
  ];

  return (
    <WebPageLayout
      header={{
        tabs: [
          { title: "Work Orders", routeName: "workOrders", replaceStack: true },
          { title: "Tickets", routeName: "tickets", replaceStack: true },
          { title: "Job Plans", routeName: "jobPlans", replaceStack: true },
          { title: "Preventative Maintenance", routeName: "preventativeMaintenances", replaceStack: true },
          { title: "System", routeName: "system", replaceStack: true },
          { title: "Labour", routeName: "labour", replaceStack: true },
        ],
      }}
    >
      <TablePageLayout
        filters={
          !isSmallScreen ? (
            <DashboardViewFilters filter={filter} onSubmit={onSubmitFilter} />
          ) : null
        }
        actions={null}
        actionsContainerStyle={{ marginBottom: 0 }}
      >
        <View style={styles.container}>
          
          {isSmallScreen && (
            <Drawer
              title="Filters"
              placement="left"
              width={340}
              onClose={() => setShowFilters(false)}
              open={showFilters}
              destroyOnClose
            >
              <DashboardViewFilters
                filter={filter}
                onSubmit={() => {
                  onSubmitFilter();
                  setShowFilters(false); // auto-close after applying
                }}
                isSmallScreen={isSmallScreen}

              />
            </Drawer>
          )}

          <div
            style={{ display: "flex", flex: 1, minHeight: 0, alignItems: "center", ...gapStyle, ...marginStyle}}>
              {isSmallScreen && (
                <div >
                  <Button
                    icon="chevron-left"
                    mode="contained-tonal"
                    onPress={() => setShowFilters(true)}
                    labelStyle={{ fontSize: "1vw", fontWeight: '500' }}
                  >
                    Show Filters
                  </Button>     
                </div>
              )}
            {cards.map((stat, index) => (
              <Card
                key={index}
                bordered
                onClick={() => handleCardClick(index)}
                style={{ cursor: "pointer", borderColor: "blue", borderRadius:8, flex: 1, minWidth: 120, height: "100%", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px 12px"}}>
                <div
                  style={{display: "flex",alignItems: "center",justifyContent: "center",...gapStyle,width: "100%",}}>
                  <span
                    style={{flex: 0,fontSize: "2vw",}}>
                    {stat.icon}
                  </span>
                  <span
                    style={{flex: 1,fontSize: "1vw",fontWeight: 500,whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis",textAlign: "center",}}>
                    {stat.title}
                  </span>
                  <span
                    style={{flex: 0,fontSize: "1vw",fontWeight: 600,}}>
                    {stat.value}
                  </span>
                </div>
              </Card>
            ))}
          </div>


          <div style={{display: "flex", flex: 9, minHeight: 0, ...gapStyle }}>
            <div style={{flex: 1.5, display: "flex", flexDirection: "column", minHeight: 0, ...gapStyle}}>
              <div style={{display: "flex", flex: 4, ...gapStyle, minHeight: 0,}}>
                <div style={{flex: 1, display: "flex", flexDirection: "column", minHeight: 0,}}>
                  <div ref={AssetRankBarRef} style={{ ...chartContainerStyle, flex: 1 }}> 
                    <h3 style={{ marginTop: 0, marginBottom: 0 }}>Work Order per Asset Ranking</h3>
                    <AssetRankBarChart
                      data={dashboardData?.dashboardAssetPriorityDto.workOrderPriorityCounts || []}
                      width={AssetRankBarSize?.width}
                      height={AssetRankBarSize?.height}
                      isSmallScreen={isSmallScreen}
                    />
                  </div>
                </div>

                <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, }}>
                  <div ref={StatusPieRef} style={{ ...chartContainerStyle, flex: 1 }}>
                    <h3 style={{ marginTop: 0, marginBottom: 0 }}>Work Order per Status</h3>
                    <StatusPie
                      data={dashboardData?.dashboardWorkOrderStatusDto.workOrderStatusCounts || []}
                      width={StatusPieSize?.width}
                      height={StatusPieSize?.height}
                      isSmallScreen={isSmallScreen}
                    />
                  </div>
                </div>
              </div>

              <div style={{  flex: 6, display: "flex", flexDirection: "column", minHeight: 0, }}>
                <div style={{ ...chartContainerStyle, flex: 1 }}>
                  <h3 style={{ marginTop: 0, marginBottom: 0 }}>#WO x Asset Type</h3>
                  <WorkOrderPerAssetChart
                    data={dashboardData?.dashboardWorkOrderPerAssetDto.workOrdersPerAssetType || []}
                  />
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, ...gapStyle }}>
              <div style={{ flex: 8, display: "flex", flexDirection: "column", minHeight: 0, }}>
                <div ref={buildingRef} style={{ flex: 1, minHeight: 0,  alignItems: "flex-end",  }}>
                  {buildingSize && (
                    <BuildingMap
                      imageSrc={require("../../../../assets/images/PGC.png")}
                      originalWidth={buildingSize.width}
                      originalHeight={buildingSize.height}
                      buildings={imageData}
                  />
                  )}
                </div>
              </div>

              <div style={{ flex: 2, display: "flex", flexDirection: "column", minHeight: 0, }}>
                <div ref={PreventiveChartRef} style={{ ...chartContainerStyle, flex: 1 }}>
                  <PreventiveCorrectiveChart
                    data={
                      dashboardData?.dashboardCorrectivePreventiveDto
                        .dashboardPreventiveCorectiveCounts || []
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </View>
      </TablePageLayout>

      <DashboardOpenWorkOrdersModal
        workOrders={dashboardData?.dashboardCountDto.openWorkOrders || []}
        isOpen={WOModalOpen}
        onClose={() => setOpenWOModalOpen(false)}
      />
      <DashboardOverDueWorkOrdersModal
        workOrders={dashboardData?.dashboardCountDto.overDueWorkOrders || []}
        isOpen={overDueWOModalOpen}
        onClose={() => setOverDueWOModalOpen(false)}
      />
      <DashboardTicketModal
        tickets={dashboardData?.dashboardCountDto.openTickets || []}
        isOpen={ticketModalOpen}
        onClose={() => setTicketModalOpen(false)}
      />
    </WebPageLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: 8,
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#CECECE",
    borderRadius: 6,
  },
  chartContainer: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflow: "visible",
    padding: 8,
    borderRadius: 16,
    border: '2px solid #ccc',
    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
    display: "flex",
    flexDirection: "column",
  },
});
